import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import Pickup from "../../components/Pickup/Pickup";
import PickupDate from "../../components/PickupDate/PickupDate";
import TrackOrder from "../../components/TrackOrder/TrackOrder";
import TrackOrderNow from "../../components/TrackOrderNow/TrackOrderNow";
import DeliveryModal from "../DeliveryModal/DeliveryModal";
import { getOutletInformation } from "../../actions/autocompleteActions";
import { useDispatch } from "react-redux";
import CartRender from "./CartRender";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PopUp from "../Modals/Popup";
import OutletInfo from "./OutletInfo"; //OUTLET COMPONENT FOR DETAILS REGARDING DELIVERY CHARGES
import { getSelectedOutlet } from "./outletFunctions";
import OrderPlaced from "../OrderPlaced/OrderPlaced";
import Paynow from "../PaymentMethod/Paynow";
import "../../assets/css/form.css";
import "./Rightbar.css";
import "../../assets/css/modal.css";
import cartImg1 from "../../assets/svgs/red.png";
import exclamation from "../../assets/svgs/exclamation.png";
import arrowup from "../../assets/svgs/arrow-up.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiMapPinLine, RiHomeLine, RiBankCardLine, RiTimeLine } from "react-icons/ri";
import CartIcon from "../../assets/icons/cart-icon.svg.jsx";
import ChooseModal from "../OrderItem/chooseModal";
import { useRef } from "react";
import {
  cartLocal,
  getProductsAvailability
} from "../../actions/productActions";
import {
  clearCart,
  clearPayment,
  // clearCartSingle,
  placeOrder,
  getTaxes,
  submitOrder,
  updateOrder,
  submitPayment,
  getPreparationTime,
  callCheckPickupDelivery,
  checkOutProduct
} from "../../actions/productActions";
import PaymentMethod from "../PaymentMethod/PaymentMethod";
import { readCheckoutResponse, readApiError, redirectToAirwallexCheckout } from "../../utils/airwallex";
import GatewaySelect from "../PaymentMethod/GatewaySelect";
import HitPayQrModal from "../PaymentMethod/HitPayQrModal";
import { readHitPayResponse } from "../../utils/hitpay";
import cartImg from "../../assets/svgs/red.png"
import { FaChevronDown } from "react-icons/fa";
import {
  OWN_DELIVERY_MODE,
  isOwnDeliveryMode,
  getDeliveryFulfilmentMode,
  setDeliveryFulfilmentMode,
  isMinOrderMet,
  getMinOrderMessage,
  resolveOwnDeliveryFee
} from "../../utils/deliveryMode";
import { getOwnDeliveryQuote } from "../../actions/productActions";
const RightSidebar = (props) => {
  const { showBilling, setShowBilling } = props;
  const [showCartTotal, setShowCartTotal] = useState(false);
  const show = props.show;
  const [orderPlaced, setorderPlaced] = useState(true);
  const [showCashRegisterbanner, setShowCashRegisterbanner] = useState(false)
  const [replaceContext, setReplaceContext] = useState(null); // 👈 ADD
  const [showModal, setShowModal] = useState(false);
  const [productDataModal, setProductDataModal] = useState(null);
  // const [ShowCashRegisterbannermessage, setShowCashRegisterbannermessage] = useState(false)

  const cartIconRef = useRef(null);
  //STATE VARIABLES TO SET THE DEFAULTS THE FIRST TIME USER OPENS UP THE SIDEBAR
  const hideDelivery = props.business_location ? props.business_location[0].hide_delivery_for_web : 0
  const hidePickup = props.business_location ? props.business_location[0].hide_pickup_for_web : 0
  const [method, setMethod] = useState(1);
  const [methodText, setMethodText] = useState("Delivery");


  //----------------------------------------------------------------------------

  const [address, setAddress] = useState(null);
  const [outlate, setOutlate] = useState(null);
  const [load, setLoad] = useState(false);
  const [taxload, setTaxLoad] = useState(false);
  const [tax, setTax] = useState(null);
  const [methodToggle, setToggle] = useState(false) //Remove_Later
  const [showPickup, setShowPickup] = useState(false);
  const [showPickupDate, setShowPickupDate] = useState(false);
  const [showtrackOrder, setShowTrackOrder] = useState(false);
  const [showTrackNow, setShowTracknow] = useState(false);
  const [order, setOrder] = useState([]);
  const history = useHistory();
  const [showDelivery, setShowDelivery] = useState(false);
  const [lshow, setLshow] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [cartData, setCartData] = useState(null);
  const [SRVChargesRate, setSRVChargesRate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [roundVal, setRoundVal] = useState(0);
  // const [showBilling, setShowBilling] = useState(false);
  //ORDER PLACED STATES *****************************************
  const [bshowOrderSuccess, setShowOrderSuccess] = useState(false)

  //PAYMENT METHOD STATES ***************************************
  const [bShowPayment, setShowPayment] = useState(false)
  const [showGatewaySelect, setShowGatewaySelect] = useState(false)
  const [gatewaySubmitting, setGatewaySubmitting] = useState(false)
  const [hitpayCheckout, setHitpayCheckout] = useState(null)
  const gatewaySubmitLock = useRef(false) //BLOCKS DUPLICATE PAYMENT SUBMISSIONS
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [bShowPaynow, setShowPaynow] = useState(false)
  const [paynowNumber, setPaynowNumber] = useState(localStorage.paynow_number === "null" ? null : localStorage.paynow_number)
  const [amountRoundingMethod, setAmountRoundingMethod] = useState(localStorage.amount_rounding_method === undefined ? null : localStorage.amount_rounding_method)

  const [showBlockedPopup, setShowBlockedPopup] = React.useState(false);
  const [blockedList, setBlockedList] = React.useState([]);


  //OUTLETS AND DELIVERY CHARGE STATES **************************
  const [bShowOutlet, setShowOutlet] = useState(false) //USED TO SHOW THE OUTLET MODAL FOR DELIVERY

  const [deliveryInformation, setDeliveryInformation] = useState({
    deliveryCharge: 0.0,
    deliveryOutName: "",
  });
  const [pickupRounded, setPickupRounded] = useState(0);

  //DEL-1 :: OWN DELIVERY *****************************************
  const deliveryFulfilmentMode =
    props.business_location?.[0]?.delivery_fulfilment_mode ?? getDeliveryFulfilmentMode();
  const ownDelivery = isOwnDeliveryMode(deliveryFulfilmentMode); //FALSE KEEPS THE LALAMOVE FLOW AS IS

  useEffect(() => {
    if (props.business_location && props.business_location[0]) {
      setDeliveryFulfilmentMode(props.business_location[0].delivery_fulfilment_mode);
    }
  }, [props.business_location]);

  //LAST /own_delivery_quote RESULT - HOLDS THE FEE AND THE MINIMUM ORDER RESULT
  const ownDeliveryQuote = ownDelivery ? props.ownDeliveryQuote : null;
  const ownDeliveryMinOrderBlocked =
    ownDelivery && method === 1 && !isMinOrderMet(ownDeliveryQuote);
  const ownQuoteInFlight = useRef(false); //KEEPS A DOUBLE CLICK FROM FIRING THE QUOTE TWICE
  const ownQuoteSignatureRef = useRef(""); //LAST CART SIGNATURE A QUOTE WAS FETCHED FOR

  //DEL-2 :: MIRRORS THE QUOTE'S FEE INTO deliveryInformation.deliveryCharge - THE SAME FIELD THE CART TOTAL
  //AND THE CHECKOUT PAYLOADS ALREADY READ, SO NOTHING ELSE HAS TO CHANGE TO PICK UP A FRESH QUOTE.
  //A QUOTE THAT COMES BACK UNPRICED (NO delivery_charges, OR A BARE 0 WITHOUT is_free) FALLS BACK TO THE
  //STORE'S OWN Own Delivery Fee INSTEAD OF SILENTLY CHARGING $0.
  const applyOwnDeliveryQuote = (quote) => {
    if (!quote) return;
    const configuredFee = props.business_location?.[0]?.own_delivery_fee;
    setDeliveryInformation((current) => ({
      ...current,
      deliveryCharge: resolveOwnDeliveryFee(quote, configuredFee),
      deliveryCurrency: quote.currency
    }));
  };

  // Quotes the current cart with POST /own_delivery_quote - once from the reactive effect
  // below whenever the cart's products/quantities change, and once more from the checkout
  // button so the latest figure is confirmed right before billing.
  const requestOwnDeliveryQuote = async () => {
    ownQuoteInFlight.current = true;
    try {
      const result = (await props.getOwnDeliveryQuote(cartData)) || { quote: null, error: null };
      applyOwnDeliveryQuote(result.quote);
      return result;
    } finally {
      ownQuoteInFlight.current = false;
    }
  };

  useEffect(() => { //RE-QUOTES DELIVERY WHENEVER THE CART'S PRODUCTS/QUANTITIES CHANGE, NOT JUST AT CHECKOUT
    if (!ownDelivery || method !== 1 || ownQuoteInFlight.current) return;
    if (!Array.isArray(cartData) || cartData.length === 0) return;

    const signature = JSON.stringify(
      cartData.map((item) => [item.product_id, item.product_variation_id ?? item.variation_id, item.quantity])
    );
    if (signature === ownQuoteSignatureRef.current) return;

    const timer = setTimeout(() => {
      ownQuoteSignatureRef.current = signature;
      requestOwnDeliveryQuote();
    }, 400); //DEBOUNCED SO RAPID QTY CLICKS DON'T FIRE A QUOTE PER CLICK

    return () => clearTimeout(timer);
  }, [ownDelivery, method, cartData]);

  const openChooseModal = (context) => {
    // context comes from CartRender
    console.log("openChooseModal called with context:", context);
    setReplaceContext(context);

    // THIS IS WHAT ChooseModal EXPECTS
    setProductDataModal({
      id: context.product.id,
      name: context.product.name,
      price: context.product.price,
      image: context.product.image,
    });

    setShowModal(true);
  };

  const [estPrepTime, setEstPrepTime] = useState(props.est_prep_time !== undefined && props.est_prep_time !== null && props.est_prep_time.length > 0 ? props.est_prep_time[0] : undefined)
  const estPrepTimeHours = estPrepTime !== undefined ? estPrepTime.est_prep_time_hours : null
  const estPrepTimeMinutes = estPrepTime !== undefined ? estPrepTime.est_prep_time_minutes : null
  const isInclusiveGST = localStorage.getItem("apply_inclusive_gst") === "true"
  // round off to the nearest

  // const amount_rounding = (number, multiple = 0) => {

  //   number = parseFloat((number).toFixed(2));//parseFloat((number.toFixed(2)) + '0'); // cut off extra value.

  //   let rounded_number = number // input value

  //   let nearestTo = parseFloat(multiple); // nearest to eg. 0.05

  //   if (multiple > 0) {

  //     let x = parseFloat((number.toFixed(2)) + '0'); // input value

  //     rounded_number = (nearestTo) * Math.round(x / nearestTo)

  //   }

  //   var output = {
  //     number: parseFloat((rounded_number.toFixed(2)) + '0'),
  //     diff: parseFloat(((rounded_number - number).toFixed(2)) + '0')
  //   }

  //   return output;
  // }
  const amount_rounding = (number, multiple = 0) => {
    number = parseFloat(number.toFixed(2));
    const nearestTo = parseFloat(multiple);

    if (!nearestTo || nearestTo <= 0) {
      return { number, diff: 0 };
    }

    // Always round DOWN (floor)
    const rounded_number = Math.floor(number / nearestTo) * nearestTo;

    // Ensure 2 decimal places
    const final_number = parseFloat(rounded_number.toFixed(2));

    // Difference will always be negative or zero
    const diff = parseFloat((final_number - number).toFixed(2));

    return { number: final_number, diff };
  };
  useEffect(() => {
    // setPaymentMethod(props.outletInfo?.method === 1 ? "Stripe" : null);
    setPaymentMethod("Stripe")
  }, [props.outletInfo?.method]);

  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }, [props.show])

  // Escape closes the cart panel
  useEffect(() => {
    if (!props.show) return undefined;
    const onKey = (e) => { if (e.key === "Escape") props.closeRightbar(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [props.show])

  useEffect(() => {
    const orderType = localStorage.getItem("order_type");
    if (orderType === "1") {
      setMethodText("Delivery");
      setMethod(1)
    } else if (orderType === "2") {
      setMethodText("Pick Up");
      setMethod(2)
    } else {
      setMethod(1)
      setMethodText("Delivery"); // default
    }
  }, [hideDelivery])

  //   useEffect(() => {
  //   const orderType = localStorage.getItem("order_type");

  //   if (orderType === "1") {
  //     setMethodText("Delivery");
  //   } else if (orderType === "2") {
  //     setMethodText("Pick Up");
  //   } else {
  //     setMethodText("Delivery"); // default
  //   }
  // }, []);

  useEffect(() => {
    let outlet = props.outlates?.business_location?.filter(outlates => {
      return outlates.id === parseInt(localStorage.outlate)
    });
    if (outlet) {
      if (outlet.length > 0) {
        let oldOrder = order
        oldOrder["out_id"] = outlet[0].id
        oldOrder["out_name"] = outlet[0].name
        setOrder(oldOrder)
      }
    }
  }, [props.outlates]);

  useEffect(() => {
    if (!load) {
      props.getTaxes();
      setLoad(true);
    }

    if (
      props.loading === false &&
      props.tax !== null &&
      taxload === false
    ) {
      setTax(props.tax);
      setTaxLoad(true);
    }
  }, [load, props, order, taxload]);

  useEffect(() => {
    //PREVENT SUCCESS MODAL FROM SHOWING TWICE IF ON THE PAYMENT PAGE
    if (props.payment && (paymentMethod === "cash" || paymentMethod === "paynow") && history.location.pathname !== "/payment") {
      clearCart()
      setShowOrderSuccess(true)
    }
  }, [props.payment]);

  const roundoffValue = (value) => {
    const formattedTotal = parseFloat(value.toFixed(2));

    const roundingMethod = parseFloat(
      props?.business_location?.[0]?.amount_rounding_method ?? 0
    );

    let roundingAmount = 0;
    let totalAfterRounding = formattedTotal;

    if (roundingMethod > 0) {
      roundingAmount =
        ((formattedTotal * 10000) % (roundingMethod * 10000)) / 10000;

      if (roundingAmount > 0) {
        totalAfterRounding = parseFloat(
          (formattedTotal - roundingAmount).toFixed(2)
        );
        setRoundVal(roundingAmount);
        // setIsNegativeRounding(true);
      } else {
        setRoundVal(0);
        // setIsNegativeRounding(false);
      }
    } else {
      setRoundVal(0);
      // setIsNegativeRounding(false);
    }

    console.log("Rounding Amount:", roundingAmount);
    return totalAfterRounding;
  };


  useEffect(() => {
    let tempCartData = JSON.parse(localStorage.getItem("cart"));
    let gstRate = 0;
    let srvChargeRate = 0;

    if (tax) {
      tax.forEach(eachTax => {
        switch (eachTax.name) {
          case "GST":
            gstRate = eachTax.amount;
            break;
          // case "Service Charge":
          //   srvChargeRate = eachTax.amount;
          //   setSRVChargesRate(srvChargeRate);
          //   break;
          default:
            break;
        }
      });
    }

    if (tempCartData?.length) {
      let arrayTotal = tempCartData.reduce(function (acc, val) {
        return parseFloat(acc) + parseFloat(val.price);
      }, 0);

      tempCartData.sub = arrayTotal;

      // add total amout based on minimum_order_value and small_order_fee and free_delivery_order_value
      let totalFee = 0
      if (props.business_location) {
        arrayTotal = parseFloat(arrayTotal);
        const loc = props.business_location[0];

        if (ownDelivery) {
          // DEL-2 :: THE REAL FEE IS THE LIVE /own_delivery_quote. THE REACTIVE QUOTE EFFECT BELOW KEEPS IT
          // MIRRORED INTO deliveryInformation.deliveryCharge, WHICH ALREADY FEEDS THE TOTAL VIA THE EXISTING
          // srvCharge ADDITION FURTHER DOWN - SO IT IS NOT ADDED A SECOND TIME HERE. OWN DELIVERY HAS NO
          // SMALL-ORDER SURCHARGE TIER: FALLING BELOW THE MINIMUM BLOCKS CHECKOUT (ownDeliveryMinOrderBlocked)
          // RATHER THAN CHARGING EXTRA, SO minimum_order_value/free_delivery_order_value ARE DISPLAY-ONLY HERE.
          const isFree = ownDeliveryQuote?.isFree === true;
          const quotedFee = deliveryInformation?.deliveryCharge != null && !isNaN(deliveryInformation.deliveryCharge)
            ? parseFloat(deliveryInformation.deliveryCharge)
            : 0;

          totalFee = arrayTotal;
          tempCartData.small_order_fee = 0;
          tempCartData.delivery_fee = isFree ? 0 : quotedFee;
          tempCartData.deliveryIsFree = isFree;
          tempCartData.minimum_order_value = ownDeliveryQuote?.minOrderValue ??
            (loc.own_delivery_min_order != null && !isNaN(loc.own_delivery_min_order) ? parseFloat(loc.own_delivery_min_order) : 0);
          tempCartData.free_delivery_order_value =
            loc.own_delivery_free_threshold != null && !isNaN(loc.own_delivery_free_threshold) ? parseFloat(loc.own_delivery_free_threshold) : 0;
        } else {
          let minimum_order_value = loc.minimum_order_value != null && !isNaN(loc.minimum_order_value) ? parseFloat(loc.minimum_order_value) : 0;
          let delivery_fee = loc.delivery_fee != null && !isNaN(loc.delivery_fee) ? parseFloat(loc.delivery_fee) : 0;
          let free_delivery_order_value = loc.free_delivery_order_value != null && !isNaN(loc.free_delivery_order_value) ? parseFloat(loc.free_delivery_order_value) : 0;
          // let flat_delivery_fee = parseFloat(props.business_location[0].flat_delivery_fee) ?? 100
          let small_order_fee = loc.small_order_fee != null && !isNaN(loc.small_order_fee) ? parseFloat(loc.small_order_fee) : 10;
          let appliedDeliveryFee = (method === 2) ? 0 : delivery_fee;
          // let appliedflatDeliveryFee = (method === 2) ? 0 : flat_delivery_fee;
          if (arrayTotal >= free_delivery_order_value) {
            totalFee = arrayTotal;
            tempCartData.small_order_fee = 0
            tempCartData.delivery_fee = 0
            // tempCartData.flat_delivery_fee = 0
          } else if (arrayTotal < minimum_order_value) {
            totalFee = arrayTotal + small_order_fee + appliedDeliveryFee;
            tempCartData.small_order_fee = small_order_fee
            tempCartData.delivery_fee = appliedDeliveryFee
            // tempCartData.flat_delivery_fee = appliedflatDeliveryFee
          } else {
            totalFee = arrayTotal + appliedDeliveryFee;
            tempCartData.small_order_fee = 0
            tempCartData.delivery_fee = appliedDeliveryFee
            // tempCartData.flat_delivery_fee = appliedflatDeliveryFee
          }

          tempCartData.minimum_order_value = minimum_order_value

          tempCartData.free_delivery_order_value = free_delivery_order_value
        }
      }

      if (method === 1) {

        //let srvCharge = (arrayTotal) * (srvChargeRate / 100);
        let srvCharge = deliveryInformation?.deliveryCharge ? parseFloat(deliveryInformation?.deliveryCharge) : 0 //DELIVERYINFORMATION FROM OUTLETINFO.JS
        let gst = (arrayTotal) * (gstRate / 100);
        if (isInclusiveGST) {
          gst = arrayTotal / (100 + gstRate) * gstRate;
        }
        let billTotal = srvCharge + totalFee;
        if (!isInclusiveGST) {
          billTotal += gst;
        }
        tempCartData.srvCharge = srvCharge;
        tempCartData.gst = gst;
        tempCartData.amountRoundingDiff = 0;
        const roundedResult = roundoffValue(billTotal);
        tempCartData.sum = parseFloat(roundedResult).toFixed(2);
        tempCartData.sum_wo_tax = parseFloat(arrayTotal).toFixed(2);
      } else {
        let gst = (arrayTotal) * (gstRate / 100);
        if (isInclusiveGST) {
          gst = arrayTotal / (100 + gstRate) * gstRate;
        }
        let billTotal = totalFee;
        if (!isInclusiveGST) {
          billTotal += gst;
        }
        let finalBillTotal = roundoffValue(billTotal);
        tempCartData.srvCharge = 0;
        tempCartData.gst = gst;
        tempCartData.amountRoundingDiff = parseFloat((finalBillTotal - billTotal).toFixed(2));
        setPickupRounded(tempCartData.amountRoundingDiff);
        tempCartData.sum = parseFloat(finalBillTotal).toFixed(2);
        tempCartData.sum_wo_tax = parseFloat(arrayTotal).toFixed(2);
      }
    }

    setCartData(tempCartData);
    console.log(tempCartData,'tempCartData')

    var serviceFee = [];
    serviceFee.push({
      'cart_count': tempCartData?.length,
      'd_charge': (tempCartData?.srvCharge ? tempCartData.srvCharge : 0).toFixed(2),
      'gst_charge': (tempCartData?.gst ? tempCartData.gst : 0).toFixed(2),
      'cart_sum_price': (tempCartData?.sum) ? tempCartData?.sum : 0,
      'cart_sum_wo_tax_price': (tempCartData?.sum_wo_tax) ? tempCartData?.sum_wo_tax : 0,
      'small_order_fee': (tempCartData?.small_order_fee) ? tempCartData?.small_order_fee : 0,
      'delivery_fee': (tempCartData?.delivery_fee) ? tempCartData?.delivery_fee : 0,
    });

    localStorage.setItem('serviceFee', JSON.stringify(serviceFee));

    if (
      props.loading === false &&
      props.add_to_cart &&
      props.add_to_cart.data &&
      Object.keys(props.add_to_cart.data).length === 0
    ) {
      props.updateCart(null);
    }

    if (
      props.loading === false &&
      !orderPlaced &&
      props.order &&
      props.order.success &&
      Object.keys(props.order.data).length > 0
    ) {
      setorderPlaced(true);
      props.closeRightbar();
      history.push("/payment/" + props.order.data.id);
    }
  }, [history, orderPlaced, props, tax, method, deliveryInformation.deliveryCharge, amountRoundingMethod]);

  useEffect(() => { //WHEN ADDRESS FROM DELIVERY MODAL CHANGES(WHEN DATA FROM ADDRESS IS SUPPLIED), TRIGGER THIS USE EFFECT
    // UNCOMMENT LATER***************************************************************************************
    // if (props.auth.isAuthenticated){ //CHECK IF USER IS LOGGED IN TO AVOID RUN-TIME ERROR
    //   const userDetails = JSON.parse(props.auth.user).data.user 

    //   if (address) {
    //     props.getOutletInformation({
    //       "latitude": address.latitude,
    //       "longtitude":  address.longtitude,
    //       "full_address": address.full_address,
    //       "customer_name": userDetails.fname,
    //       "customer_phone": userDetails.contactNo,
    //       "customer_remark": ""
    //     })
    //   }
    // }

    if (address) {
      if (props.auth?.isAuthenticated) {
        const userData = JSON.parse(localStorage.headers).data.user
        console.log(userData)
        props.getOutletInformation({
          "latitude": address.latitude,
          "longtitude": address.longtitude,
          "full_address": address.full_address,
          "customer_name": userData.fname, //CHANGE TO REAL NAME LATER,
          "customer_phone": userData.contactNo, //CHANGE TO REAL PHONE NUMBER LATER,
          "customer_remark": address.note
        })
      }
    }

  }, [address, props.auth.isAuthenticated])

  useEffect(() => {
    if (cartData !== null) {
      setEstPrepTime(props.est_prep_time !== undefined && props.est_prep_time !== null ? props.est_prep_time[0] : undefined)
    }
    if (cartData === null) {
      setEstPrepTime(undefined)
    }
  }, [cartData])

  const location = useLocation()
  useEffect(() => {
    props.getPreparationTime();

  }, [])

  const clearCart = () => {
    props.clearCart();
    localStorage.removeItem("cart");
    localStorage.removeItem("cartID");
  };

  const cartId = () => {
    if (!cartData) {
      return false;
    }

    let cartString = "";
    let cdata = cartData;

    if (cdata && Object.keys(cdata).length > 0) {
      Object.keys(cdata).map((key, index) => {
        if (!isNaN(key)) {
          cartString += cdata[key].id + ",";
        }
      });
      return cartString;
    } else {
      return false;
    }
  };

  const ProcessCheckOut = async () => {
    setLoading(true);
    try {
      let cart_id = cartId();

      if (!cart_id) {
        setPopupText("Your cart is empty!");
        setLshow(true);
        return;
      } else if (!localStorage.login) {
        setPopupText("Login is required to make payment");
        setLshow(true);
        return;
      } else if (localStorage.login && localStorage.cart) {
        if (!localStorage.d_address && method === 1) {
          setPopupText("Select Address!");
          setLshow(true);
          return;
        }
        // else if (props?.getCurrentOutlet?.name === "") {
        //   setPopupText("Select Outlet!");
        //   setLshow(true);
        //   return;
        // } 

        else if (!localStorage.outlate && method === 2) {
          setPopupText("Select Outlet!");
          setLshow(true);
          return;
        } else if (!order?.time && !localStorage.date && method === 2) {
          setPopupText("Select time and date!");
          setLshow(true);
          return;
        } else if (!deliveryInformation.deliveryOutName && method === 1) {
          setPopupText("Select delivery Outlet!");
          setLshow(true);
          return;
        } else if (!order.time) {
          setPopupText("Please select time!");
          setLshow(true);
          return;
        } else {
          //DEL-1/DEL-2 :: CONFIRM THE STORE'S OWN QUOTE BEFORE SHOWING THE BILL
          if (ownDelivery && method === 1) {
            if (ownQuoteInFlight.current) return; //A QUOTE IS ALREADY ON THE WAY, IGNORE THE EXTRA CLICK

            const { quote, error } = await requestOwnDeliveryQuote(); //ALSO APPLIES THE FEE TO deliveryInformation

            if (!quote) { //SHOWS WHAT THE API SAID WHEN IT SAID ANYTHING USEFUL
              setPopupText(error || "We could not get the delivery charge right now. Please try again.");
              setLshow(true);
              return;
            }

            if (!isMinOrderMet(quote)) { //MINIMUM ORDER NOT MET - CHECKOUT STOPS HERE
              setPopupText(getMinOrderMessage(quote, cartData?.sub));
              setLshow(true);
              return;
            }
          }

          setShowBilling(true); //SAME PAGE, NO ROUTE CHANGE - THE NETWORK REQUEST STAYS INSPECTABLE
        }
        // let products = cartData?.map((product, index) => {
        //   return ({
        //     product_type: "single",
        //     unit_price: product.product_price,
        //     line_discount_type: '',
        //     line_discount_amount: '',
        //     item_tax: 0.00, //fix
        //     tax_id: "", //fix
        //     sell_line_note: "", //fix
        //     modifier: (product.variation_id).split(','),
        //     modifier_price: product.variation_price,
        //     modifier_set_id: (product.variation_set_id).split(','),
        //     modifier_quantity: (product.variation_quantity).split(','),
        //     product_id: product.product_id,
        //     variation_id: product.product_variation_id,
        //     enable_stock: 0,
        //     quantity: parseFloat(product.quantity),
        //     product_unit_id: product.unit_id,
        //     base_unit_multiplier: 1,
        //     unit_price_before_discount: product.unit_price,
        //     unit_price_inc_tax: product.unit_price,
        //     weight: "",
        //     printed: product.printed
        //   });
        // });//without variation

        localStorage.setItem("time", order?.time);
        localStorage.setItem("order_type", method);
        // localStorage.setItem("products", JSON.stringify([products]));
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };
  const changeMethod = (key) => {
    if (key === 1) {
      setMethodText("Delivery");
    } else {
      setMethodText("Pick Up");
    }
    setMethod(key);

    localStorage.setItem("order_type", key);
  };
  const showPickFunction = () => {

    if (!address && method === 1) {
      setPopupText("Add your address");
      setLshow(true);
      return;
    }
    setShowPickup(true);
  };
  const pickupDateFunction = () => {
    setShowPickupDate(true);
    setShowPickup(false);
  };

  const showTrackOrderNowFunction = () => {
    setShowTrackOrder(false);
    setShowTracknow(true);
  };

  const trackOrderPage = () => {
    setShowTracknow(true);
    history.push("/track-order");
  };

  const trackOrderFunction = () => {
    setShowPickupDate(false);
    setShowTrackOrder(true);
  };

  //FUNCTION FOR MODAL POPUP(DELIVERY)
  const showDelivary = () => {
    setShowDelivery(true);
  };
  //----------------------------------
  const showOutlet = () => {
    if (!loading) {
      setShowOutlet(true)
    }
  }

  const closeOutlet = () => {
    setShowOutlet(false)
  }

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const currentPaymentMethod = paymentMethod;

  //CONFIRM & PROCEED :: ASKS WHICH GATEWAY TO USE, THE EXISTING CHECKOUT RUNS AFTER THE PICK
  const handleProceed = () => {
    if (gatewaySubmitLock.current) return;
    setShowGatewaySelect(true);
  };

  const handleGatewayProceed = async (gateway) => {
    if (gatewaySubmitLock.current) return;
    gatewaySubmitLock.current = true;
    setGatewaySubmitting(true);
    try {
      setPaymentMethod(gateway);
      setShowGatewaySelect(false);
      await proceedToPayment(gateway);
    } finally {
      gatewaySubmitLock.current = false;
      setGatewaySubmitting(false);
    }
  };

  const proceedToPayment = async (selectedMethod) => {
    const paymentMethod = selectedMethod || currentPaymentMethod;
    try {
      //DEL-1 :: LAST GATE BEFORE PAYMENT, THE CART MAY HAVE CHANGED ON THE BILLING SCREEN
      if (ownDeliveryMinOrderBlocked) {
        setPopupText(getMinOrderMessage(ownDeliveryQuote, cartData?.sub));
        setLshow(true);
        return;
      }

      const now = new Date();
      let checkPickupDeliverypayload = {
        "current_date": now.toISOString().split("T")[0],
        "current_time": now.toTimeString().split(" ")[0],
        "business_id": localStorage.business_id,
        "location_id": localStorage.location_id
      }

      const checkPickupDelivery = await callCheckPickupDelivery(checkPickupDeliverypayload)
      if (!checkPickupDelivery.status) {
        setPopupText(checkPickupDelivery.errorMessage ?? "Order is currently paused. Please try again later");
        setLshow(true);
        return;
      }

      if (localStorage.getItem('location_id') != null) {
        const locationId = localStorage.getItem("location_id");
        if (locationId) {
          try {
            let data = {
              location_id: locationId
            }
            const result = await axios.post("/rapyd/checkcashregister", data);
            if (result.data.status === 'closed') {
              setShowCashRegisterbanner(true)
              toast.error(result.data.message);
              // setShowCashRegisterbannermessage(result.data.message)
              return
            } else {
              setShowCashRegisterbanner(false)
              // setShowCashRegisterbannermessage("")
            }
            if (result.data.status === 'open') {
              setShowCashRegisterbanner(false)
              // setShowCashRegisterbannermessage("")
            }
          } catch (err) {
            console.error("Error:", err);
          }
        };
      }

      const buildComboPayload = (product) => {
        const combo_products_id_list = product.combo_products.map(
          (item) => item.id
        );
        const combo_products = [];

        product.combo_products_set.forEach((data) => {
          const baseId = Number(data.base_product_id);
          const setId = Number(data.product_id);
          const modId = Number(data.id);
          const modQty = Number(data.qty);
          const modPrice = Number(data.sell_price_inc_tax);

          let group = combo_products.find(
            (cp) => cp.combo_products_id === baseId
          );

          if (!group) {
            group = {
              combo_products_id: baseId,
              combo_modifier_set_id: [],
              combo_modifier: [],
              combo_modifier_quantity: [],
              combo_modifier_price: [],
            };
            combo_products.push(group);
          }

          let setIndex = group.combo_modifier_set_id.indexOf(setId);

          if (setIndex === -1) {
            group.combo_modifier_set_id.push(setId);
            group.combo_modifier.push(modId);
            group.combo_modifier_quantity.push(modQty);
            group.combo_modifier_price.push(modPrice.toString());
          } else {
            group.combo_modifier_quantity[setIndex] += modQty;
            group.combo_modifier_price[setIndex] = modPrice.toString();
            if (!group.combo_modifier.includes(modId)) {
              group.combo_modifier.push(modId);
            }
          }
        });

        return {
          combo_products_id: combo_products_id_list,
          combo_products,
        };
      };

      let products = cartData?.map((product, index) => {
        let comboPayload = null;

        if (
          Array.isArray(product?.combo_products) &&
          product.combo_products.length > 0 &&
          Array.isArray(product?.combo_products_set)
        ) {
          comboPayload = buildComboPayload(product);
        }
        return ({
          product_type: "single",
          unit_price: product.product_price,
          line_discount_type: '',
          line_discount_amount: '',
          item_tax: 0.00, //fix
          tax_id: "", //fix
          sell_line_note: "", //fix
          modifier: (product.variation_id).split(','),
          modifier_price: product.variation_price,
          modifier_set_id: (product.variation_set_id).split(','),
          modifier_quantity: (product.variation_quantity).split(','),
          product_id: product.product_id,
          variation_id: product?.product_variation_id || product?.variation_id,//product.variation_id,
          enable_stock: 0,
          quantity: parseFloat(product.quantity),
          product_unit_id: product.unit_id,
          base_unit_multiplier: 1,
          unit_price_before_discount: product.unit_price,
          unit_price_inc_tax: product.unit_price,
          weight: "",
          printed: product.printed,
          combo_products_id: comboPayload?.combo_products_id || [],
          combo_products: comboPayload?.combo_products || []

        });
      }); //variation

      if (method === 1) {
        const userData = JSON.parse(localStorage.headers).data.user
        if (address) {
          let data = {
            d_address: JSON.stringify(address),
            cart_id: cartId(),
            order_type: 1,
            ...order
          };
          data.amount_rounding_method = props?.business_location?.[0]?.amount_rounding_method ?? 0//amountRoundingMethod
          data.round_off_amount = roundVal;

          console.log("data to be sent to place order:", data)

          localStorage.setItem("deliveryInformation",
            JSON.stringify({
              ...deliveryInformation,
              //DEL-1 :: TAGS THE ORDER SO THE PAYMENT PAGE KNOWS NOT TO BOOK LALAMOVE
              ...(ownDelivery ? { deliveryMode: OWN_DELIVERY_MODE } : {}),
              customerLat: address.latitude,
              customerLong: address.longtitude,
              customerAddress: address.full_address,
              customerName: userData.fname,
              customerPhone: userData.contactNo,
              note: address.note
            }))
          // props.placeOrder(data);
          // setorderPlaced(false);
          props.closeRightbar();
          if (paymentMethod === 'Stripe' || paymentMethod === 'stripe') {
            await createCardPaymentRequest(products, data)
          } else if (paymentMethod === 'Airwallex') {
            await createAirwallexPaymentRequest(products, data)
          } else if (paymentMethod === 'HitPay') {
            await createHitPayPaymentRequest(products, data)
          } else {
            history.push("/payment");
          }
        } else {
          setPopupText("Select address and time!");
          setLshow(true);
        }
        return;
      } else if (order.out_name) { //PICK UP CHECK OUT
        let data = {
          ...order,
          cart_id: cartId(),
        };
        // props.placeOrder(data);
        // setorderPlaced(false);
        props.closeRightbar();
        // console.log("amount_rounding_method", amountRoundingMethod, "round_off_amount", cartData.amountRoundingDiff)
        data.amount_rounding_method = props?.business_location?.[0]?.amount_rounding_method//amountRoundingMethod
        data.round_off_amount = roundVal;
        if (paymentMethod === "cash" || paymentMethod === "paynow") {
          let user = JSON.parse(localStorage.headers).data.user
          let date = new Date()
          date = new Date(date.toLocaleString("en-us", {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          }))
          let currentDate = date.toISOString().split("T")[0]
          let GOVT_TAX = ["GST", "SST"];
          const gstDetail = props.tax?.filter(i => GOVT_TAX.includes(i.name))?.[0];
          console.log("cartData.amountRoundingDiff", cartData.amountRoundingDiff, roundVal)

          var submit_data = {
            "business_id": localStorage.business_id,
            "user_id": user?.user_id,
            "location_id": localStorage.location_id,
            "sub_type": "",
            "contact_id": user?.contact_id,
            "search_product": "",
            "pay_term_number": "",
            "pay_term_type": "",
            "res_table_id": "",
            "res_waiter_id": "",
            "sell_price_tax": "includes",
            "type": "sell",
            "type_for_api": "Pickup",
            "products": products,
            "discount_type": "percentage",
            "discount_amount": 0,
            "additional_discount_method": '',
            "service_charges": 0,
            "tax_rate_id": gstDetail?.id,
            "tax_calculation_amount": gstDetail?.amount,
            "rp_redeemed": 0,
            "rp_redeemed_amount": 0,
            "shipping_details": "",
            "shipping_address": "",
            "shipping_status": "",
            "delivered_to": "",
            "shipping_charges": 0,
            "advance_balance": 0,
            "payment": [{
              "payment_id": "",
              "amount": 0.0,
              "method": paymentMethod === "paynow" ? "card" : "cash",
              "card_type": paymentMethod === "paynow" ? "paynow" : "credit"
            }],
            "sale_note": "",
            "staff_note": "",
            "change_return": 0,
            "additional_notes": "",
            "is_suspend": 0,
            "recur_interval": 1,
            "recur_interval_type": "days",
            "recur_repetitions": "",
            "subscription_repeat_on": "",
            "size": "all",
            "is_enabled_stock": "",
            "is_credit_sale": 0,
            "total_before_tax": parseFloat(cartData.sum_wo_tax),
            "final_total": parseFloat(cartData.sum_wo_tax) + parseFloat(cartData.gst),
            "amount_rounding_method": amountRoundingMethod,
            "round_off_amount": roundVal,
            "discount_type_modal": "percentage",
            "discount_amount_modal": "0",
            "order_tax_modal": "",
            "shipping_details_modal": "",
            "shipping_address_modal": "",
            "shipping_charges_modal": 0,
            "shipping_status_modal": "",
            "delivered_to_modal": "",
            "status": "final",
            "stripe_token": "",
            "first_name": "",
            "last_name": "",
            "gender": user.gender === "Male" ? 1 : 0,
            "billing_address": "",
            "city": "",
            "zip_code": "",
            "country": "",
            "phone": user?.contactNo,
            "email": user?.email,
            "accept_term_and_cond": 1,
            "occasional_offers": 0, //CHANGE LATER
            "d_address": "",
            "d_date": currentDate, // {* CHANGE LATERS}
            "d_time": data.time,
            "outlet": data.out_id,
            "pickup_completed": 0,
            "delivery_charges": 0.0,
            "platform": "foodDelivery",
            "small_order_fee": cartData?.small_order_fee,
            "is_inclusive_gst_applied": isInclusiveGST,
          };
          console.log("submit_data", submit_data)
          props.submitPayment(submit_data);
        } else if (paymentMethod === 'Stripe' || paymentMethod === 'stripe') {
          await createCardPaymentRequest(products, data)
        } else if (paymentMethod === 'Airwallex') {
          await createAirwallexPaymentRequest(products, data)
        } else if (paymentMethod === 'HitPay') {
          await createHitPayPaymentRequest(products, data)
        } else {
          history.push("/payment");
        }
      } else {
        setPopupText("Select Outlet and time!");
        setLshow(true);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }

  };

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  //ORDER CONTEXT SAVED VIA save_rapidpayorder BEFORE LEAVING FOR THE GATEWAY, THE BACKEND READS IT BACK ON PAYMENT
  const buildOrderContextPayload = (orderId, products, info) => {
    const payload = {
      user: JSON.parse(localStorage.headers),
      serviceFee: JSON.parse(localStorage.serviceFee)[0],
      business_id: localStorage.getItem("business_id"),
      location_id: localStorage.getItem("location_id"),
      order_type: parseInt(localStorage.getItem("order_type")),
      products: products,
      order_id: orderId,
      deliveryInformation: JSON.parse(localStorage.getItem("deliveryInformation")),
      pickup_information: info,
      tax: props.tax,
      amount_rounding_method: info.amount_rounding_method,
      round_off_amount: roundVal?.toFixed(2),
      is_inclusive_gst_applied: isInclusiveGST,
    };

    //DEL-1 :: THE BACKEND SAVES THIS ORDER VIA save_pickup_delivery, SO IT NEEDS THE OWN DELIVERY FIELDS
    if (ownDelivery && method === 1) {
      payload.delivery_mode = OWN_DELIVERY_MODE;
      payload.delivery_charges = deliveryInformation?.deliveryCharge
        ? parseFloat(deliveryInformation.deliveryCharge)
        : 0;
    }

    return payload;
  };

  const createAirwallexPaymentRequest = async (products, info) => {
    try {
      props.setPaymentLoading(true);
      const now = new Date();

      const payload = {
        amount: JSON.parse(localStorage.serviceFee)[0].cart_sum_price,
        currency: "sgd",
        country: "SG",
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        is_digital_ordering: 1,
        current_time: now.toLocaleTimeString("en-SG", { hour12: false }),
        current_date: now.toISOString().split("T")[0],
        platform: "foodDelivery",
        products: products,
        amount_rounding_method: info.amount_rounding_method,
        round_off_amount: info.round_off_amount,
      };
      if (info?.scheduledOrder) {
        payload.scheduled_at = info.scheduledOrder.scheduled_at;
        payload.type = info.scheduledOrder.type;
      }
      if (ownDelivery && method === 1) {
        payload.delivery_fulfilment_mode = OWN_DELIVERY_MODE;
      }

      const response = await axios.post("/airwallex/qr/checkout", payload);
      const parsed = readCheckoutResponse(response.data);

      if (!parsed.ok) {
        console.error("Airwallex checkout failed:", response.data);
        toast.error(parsed.message);
        return;
      }

      await axios.post("save_rapidpayorder", buildOrderContextPayload(parsed.data.merchant_order_id, products, info));

      //NEVER RESOLVES ON SUCCESS, THE SDK NAVIGATES AWAY
      await redirectToAirwallexCheckout(parsed.data);
    } catch (error) {
      console.error("Error creating Airwallex payment request:", error);
      toast.error(readApiError(error));
    } finally {
      props.setPaymentLoading(false);
    }
  };

  //HITPAY PAYNOW :: SAME PAYLOAD AS AIRWALLEX, THE QR IS SHOWN IN A POPUP INSTEAD OF REDIRECTING
  const createHitPayPaymentRequest = async (products, info) => {
    try {
      props.setPaymentLoading(true);
      const now = new Date();

      const payload = {
        amount: JSON.parse(localStorage.serviceFee)[0].cart_sum_price,
        currency: "sgd",
        country: "SG",
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        is_digital_ordering: 1,
        current_time: now.toLocaleTimeString("en-SG", { hour12: false }),
        current_date: now.toISOString().split("T")[0],
        platform: "foodDelivery",
        products: products,
        amount_rounding_method: info.amount_rounding_method,
        round_off_amount: info.round_off_amount,
      };
      if (info?.scheduledOrder) {
        payload.scheduled_at = info.scheduledOrder.scheduled_at;
        payload.type = info.scheduledOrder.type;
      }
      if (ownDelivery && method === 1) {
        payload.delivery_fulfilment_mode = OWN_DELIVERY_MODE;
      }

      const response = await axios.post("/hitpay/payment_request", payload);
      const parsed = readHitPayResponse(response.data);

      if (!parsed.ok) {
        console.error("HitPay payment request failed:", response.data);
        toast.error(parsed.message);
        return;
      }

      //SAVE THE PENDING CART UNDER EVERY ID THE BACKEND MAY LOOK IT UP BY: ITS ORDER ID (WEBHOOK) AND THE HITPAY REFERENCE (payment-status PAGE)
      const saveIds = [...new Set([parsed.merchantOrderId, parsed.orderId].filter(Boolean))];
      for (const id of saveIds) {
        await axios.post("save_rapidpayorder", buildOrderContextPayload(id, products, info));
      }
      setHitpayCheckout(parsed);
    } catch (error) {
      console.error("Error creating HitPay payment request:", error);
      toast.error(readApiError(error));
    } finally {
      props.setPaymentLoading(false);
    }
  };

  const createCardPaymentRequest = async (products, info) => {
    try {
      props.setPaymentLoading(true);
      const now = new Date();

      const payload = {
        amount: JSON.parse(localStorage.serviceFee)[0].cart_sum_price,
        currency: "sgd",
        country: "SG",
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        is_digital_ordering: 1,
        current_time: now.toLocaleTimeString("en-SG", { hour12: false }),
        current_date: now.toISOString().split("T")[0],
        platform: "foodDelivery",
        products: products,
        amount_rounding_method: info.amount_rounding_method,
        round_off_amount: info.round_off_amount,
      };
      console.log("info:", info);
      if (info?.scheduledOrder) {
        payload.scheduled_at = info.scheduledOrder.scheduled_at;
        payload.type = info.scheduledOrder.type;
      }

      //DEL-1 :: LETS THE CHECKOUT ENDPOINT KNOW THIS DELIVERY IS STORE-FULFILLED, NOT VIA LALAMOVE
      if (ownDelivery && method === 1) {
        payload.delivery_fulfilment_mode = OWN_DELIVERY_MODE;
      }

      //CARD PAYMENTS GO THROUGH STRIPE FIRST. THE LOCATION API DOESN'T EXPOSE enable_stripe / enable_rapyd,
      //SO A 400 FROM /stripe/checkout (STRIPE NOT ENABLED OR CONNECT NOT FINISHED FOR THIS LOCATION)
      //FALLS BACK TO THE LOCATION'S RAPYD CHECKOUT. 4xx BODIES ARE READ INSTEAD OF THROWN.
      const keep4xx = { validateStatus: (status) => status < 500 };
      let checkout = null;
      let failureMessage = null;

      const stripeResponse = await axios.post("/stripe/checkout", payload, keep4xx);
      const stripeResult = stripeResponse.data;

      if (stripeResult?.status === "success" && stripeResult.data?.url) {
        checkout = { url: stripeResult.data.url, orderId: stripeResult.data.order_id };
      } else if (stripeResponse.status === 400) {
        const rapydResponse = await axios.post("/rapyd/checkout", payload, keep4xx);
        const rapydResult = rapydResponse.data;

        if (rapydResult?.status === "success" && rapydResult.data?.redirect_url) {
          checkout = { url: rapydResult.data.redirect_url, orderId: rapydResult.data.payment?.metadata?.order_id };
        } else if (rapydResult?.msg) {
          failureMessage = rapydResult.msg;
        } else {
          console.error("Rapyd checkout unavailable:", rapydResult);
          failureMessage = "Card payment is currently unavailable for this outlet. Please contact the store.";
        }
      } else {
        console.error("Failed to create Stripe checkout session:", stripeResult);
        failureMessage = stripeResult?.msg || stripeResult?.message;
      }

      if (checkout?.url && checkout.orderId) {
        await axios.post("save_rapidpayorder", buildOrderContextPayload(checkout.orderId, products, info));

        //REDIRECT TO THE GATEWAY'S HOSTED CHECKOUT PAGE (STRIPE OR RAPYD)
        window.location.href = checkout.url;
      } else {
        //NOTHING WAS CHARGED - KEEP THE CUSTOMER ON THE MENU WITH THEIR CART AND SAY WHY
        toast.error(failureMessage || "Unable to start card payment. Please try again.");
      }
    } catch (error) {
      console.error("Error creating card payment request:", error);
      toast.error("Unable to start card payment. Please try again.");
    } finally {
      props.setPaymentLoading(false);
    }
  };

  const handleBack = async () => {
    setShowBilling(false);
  }
  // useEffect(() => {
  //   if (method === 1) { // Delivery
  //     setPaymentMethod("Stripe"); // always Stripe for Delivery
  //   }
  // }, [method]);
  useEffect(() => {
    if (method === 1) {
      if (paymentMethod !== "Stripe") {
        setPaymentMethod("Stripe");
      }
    } else if (method === 2) {
      if (paymentMethod) {
        setPaymentMethod(null);
      }
    }
  }, [method]);

  const getEstimationRange = (cartItems) => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      return "3 - 5 minutes";
    }

    const times = cartItems
      .map((item) => Number(item.estimated_time))
      .filter((time) => !isNaN(time) && time > 0);

    if (times.length === 0) {
      return "3 - 5 minutes";
    }

    const minTime = Math.min(...times);
    const maxTime = Math.max(...times);

    return minTime === maxTime
      ? `${minTime} minutes`
      : `${minTime} minutes to ${maxTime} minutes`;
  };
  const checkAvailabilityBeforeCheckout = async () => {
    try {
      if (!cartData || cartData.length === 0) {
        return { error: false, blocked: [] };
      }
      const res = await props.getProductsAvailability(cartData);
      if (!res || !res.data || res.status !== true) {
        return { error: true, blocked: [] };
      }
      const apiProducts = res.data;
      const blockedProducts = apiProducts.filter(item => {
        const product = item.localProduct;
        if (
          product?.not_for_selling === 1 ||
          product?.not_for_pickup_delivery === 1
        ) {
          return true;
        }

        const blockedModifier = product?.selectedModifiers?.some(
          m => m.out_of_stock === 1 || m.not_for_delivery === 1
        );

        if (blockedModifier) return true;

        if (product?.out_of_stock === 1) return true;

        return false;
      });
      return { error: false, blocked: blockedProducts };

    } catch (err) {
      console.error("Availability check failed:", err);

      return { error: true, blocked: [] };
    }
  };
  const isApiErrorPopup = blockedList?.length === 1
    && blockedList[0]?.name === "Unable to verify items";
  const getBlockedMessage = (item) => {
    if (item.name === "Unable to verify items") {
      return (
        <span style={{ color: "#d9534f", fontWeight: 600 }}>
          Unable to verify product availability. Please try again.
        </span>
      );
    }
    const product = item.localProduct;
    if (
      product?.not_for_selling === 1 ||
      product?.not_for_pickup_delivery === 1
    ) {
      return (
        <span>
          <strong>{item.name}</strong> is not available for selling.
          Please remove from the cart.
        </span>
      );
    }
    const blockedModifier = product?.selectedModifiers?.find(
      m => m.out_of_stock === 1 || m.not_for_delivery === 1
    );
    if (blockedModifier) {
      return (
        <span>
          <strong>{item.name}</strong> modifier is out of stock. Please choose another one.
        </span>
      );
    }
    if (product?.out_of_stock === 1) {
      return (
        <span>
          <strong>{item.name}</strong> is out of stock.
          Please remove from the cart.
        </span>
      );
    }
    return null;
  };

  //DEL-2 :: SMALL HINT NEXT TO THE DELIVERY CHARGE ROW - MINIMUM ORDER WARNING FIRST, ELSE THE
  //FREE-DELIVERY NUDGE. NEITHER SHOWS FOR LALAMOVE, WHICH NEVER HAD THIS ROW.
  const ownDeliveryHint = (() => {
    if (!ownDelivery || method !== 1 || !cartData) return null;

    if (!isMinOrderMet(ownDeliveryQuote)) {
      return { text: getMinOrderMessage(ownDeliveryQuote, cartData?.sub), tone: "warn" };
    }

    const freeThreshold = parseFloat(cartData?.free_delivery_order_value);
    const subTotal = parseFloat(cartData?.sub) || 0;
    if (!cartData?.deliveryIsFree && freeThreshold > 0 && subTotal < freeThreshold) {
      const remaining = (freeThreshold - subTotal).toFixed(2);
      return {
        text: `Free delivery on orders over $${freeThreshold.toFixed(2)} — add $${remaining} more!`,
        tone: "hint"
      };
    }

    return null;
  })();

  return (
    <div>
      <PopUp
        text={popupText}
        show={lshow}
        closeModal={() => setLshow(false)}
        sub={cartData?.sub}
        delivery_fee={cartData?.delivery_fee}
        small_order_fee={cartData?.small_order_fee}
        gst={cartData?.gst}
        method={method}
        total={cartData?.sum}
        onProceed={proceedToPayment}
      />
      <DeliveryModal
        showOutlet={showOutlet}
        address={address}
        show={showDelivery}
        loginRef={props.loginRef}
        setAddress={setAddress}
        closeModal={() => setShowDelivery(false)}
        showPickupDate={() => pickupDateFunction()}
      // showCashRegister={()=> showCashRegister()}
      />

      <Pickup
        setPaynowNumber={setPaynowNumber}
        setOrder={setOrder}
        order={order}
        show={showPickup}
        closeModal={() => setShowPickup(false)}
        showPickupDate={() => pickupDateFunction()}
        setPaymentMethod={setPaymentMethod}
        setAmountRoundingMethod={setAmountRoundingMethod}
      />

      <PickupDate
        setOrder={setOrder}
        order={order}
        show={showPickupDate}
        method={method}
        address={address}
        closeModal={() => setShowPickupDate(false)}
        setShowPayment={setShowPayment}
      />

      <TrackOrder
        show={showtrackOrder}
        closeModal={() => setShowTrackOrder(false)}
        trackOrderNow={() => showTrackOrderNowFunction()}
      />

      <OutletInfo
        showOutlet={bShowOutlet}
        closeOutlet={closeOutlet}
        showPickupDate={() => pickupDateFunction()}
        setDeliveryInformation={setDeliveryInformation}
        deliveryInformation={deliveryInformation}
      />

      <PaymentMethod
        showPayment={bShowPayment}
        setPaymentVisible={setShowPayment}
        setPaymentMethod={setPaymentMethod}
        setAmountRoundingMethod={setAmountRoundingMethod}
        setShowPaynow={setShowPaynow}
        paynowNumber={paynowNumber}
        outletInfo={{ method }}


      />

      <HitPayQrModal
        show={!!hitpayCheckout}
        onClose={() => setHitpayCheckout(null)}
        onPaid={() => {
          //SAME HAND-OFF AS STRIPE'S RETURN URL: THE PAYMENT STATUS PAGE SAVES THE ORDER, CLEARS THE CART, THEN OPENS TRACK ORDER
          const reference = hitpayCheckout?.referenceNumber || hitpayCheckout?.orderId;
          setHitpayCheckout(null);
          history.push(`/payment-status/?reference_number=${encodeURIComponent(reference)}&is_hitpay=1&status=succeeded`);
        }}
        checkout={hitpayCheckout}
      />
      <GatewaySelect
        show={showGatewaySelect}
        onClose={() => setShowGatewaySelect(false)}
        onProceed={handleGatewayProceed}
        submitting={gatewaySubmitting}
      />

      <Paynow showPaynow={bShowPaynow} setShowPaynow={setShowPaynow} paynowNumber={paynowNumber} />

      <TrackOrderNow
        show={showTrackNow}
        closeModal={() => setShowTracknow(false)}
        trackOrder={() => trackOrderPage()}
      />

      <OrderPlaced
        clearPayment={props.clearPayment}
        show={bshowOrderSuccess}
        closeModal={() => setShowOrderSuccess(false)}
        TrackOrder={() => setShowTracknow(true)}
      />

      {
        !showBilling ?
          <div className={`modal_form mycart-dropdown ${show ? "open" : ""}`} id="myCart">
            <div className="cart-head border-bottom">
              {/* Left: Method Selector */}
              <div className="cart-head-left">
                <Dropdown className="premium-dropdown">
                  <Dropdown.Toggle id="dropdown-basic" className="cart-method-btn">
                    {methodText} <FaChevronDown size={10} style={{ marginLeft: '4px' }} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="premium-dropdown-menu">
                    {hideDelivery === 0 && (
                      <Dropdown.Item
                        onClick={() => changeMethod(1)}
                        className={method === 1 ? "active" : ""}
                      >
                        Delivery
                      </Dropdown.Item>
                    )}
                    {hidePickup === 0 && (
                      <Dropdown.Item
                        onClick={() => changeMethod(2)}
                        className={method === 2 ? "active" : ""}
                      >
                        Pick Up
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <h2 className="cart-head-title">Cart</h2>

              {/* Right: Close */}
              <div className="cart-head-right">
                <ModalCloseButton
                  onClick={props.closeRightbar}
                  style={{ position: 'static', width: '32px', height: '32px', marginLeft: 'auto' }}
                />
              </div>
            </div>
            <div className="is" id={`${method === 2 && estPrepTime !== undefined ? 'pickup' : 'delivery'}`}>

              {/* <div className={`is`}> */}              {method === 0 ? (
                <div className="panel-ember">
                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiMapPinLine />
                      Deliver to
                    </label>

                    <span
                      className="btn secondry d-block f14"
                      onClick={() => showDelivary()}
                      data-testid="select_credentials"
                    >
                      {address
                        ? address.full_address
                        : " Add my address"}
                      <i className="fa fa-angle-right right"></i>
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiHomeLine />
                      Select outlet
                    </label>
                    <span

                      style={address && props?.auth?.isAuthenticated
                        ? { opacity: 1.0, cursor: "pointer", pointerEvents: "auto" }
                        : { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }
                      }
                      className="btn secondry d-block f14"
                      onClick={() => {

                        showOutlet()

                      }}
                    >
                      {deliveryInformation.deliveryOutName ? deliveryInformation.deliveryOutName : "Select your outlet"}
                      <i className="fa fa-angle-right right"></i>
                    </span>
                  </div>

                  <div className="form-group no">
                    <label className="control-label label-with-icon">
                      <RiBankCardLine />
                      Payment method</label>

                    <span
                      style={
                        address && props?.auth?.isAuthenticated ?
                          {
                            opacity: 1.0,
                            cursor: "pointer",
                            pointerEvents: "auto"
                          } :
                          {
                            opacity: 0.4,
                            cursor: "not-allowed",
                            pointerEvents: "none"
                          }
                      }
                      onClick={() => { setShowPayment(true) }}
                      className="btn secondry d-block f14"
                    >
                      {paymentMethod ? paymentMethod[0].toUpperCase() + paymentMethod.substring(1, paymentMethod.length) : "Select payment"}
                    </span>
                  </div>

                  <div className="form-group no">
                    <label className="control-label label-with-icon">
                      <RiTimeLine />
                      Delivery Time</label>
                    <span
                      onClick={() => pickupDateFunction()}
                      className="btn secondry d-block f14 pickup-btn"
                      style={
                        address && props?.auth?.isAuthenticated ?
                          {
                            opacity: 1.0,
                            cursor: "pointer",
                            pointerEvents: "auto"
                          } :
                          {
                            opacity: 0.4,
                            cursor: "not-allowed",
                            pointerEvents: "none"
                          }
                      }
                    >
                      {order.date ? order.date : "Select date and "}
                      {order.time ? order.time : "Time"}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="panel-ember">

                  {method === 1 && (
                    <div className="form-group">
                      <label className="control-label">
                        <RiMapPinLine />
                        Deliver to</label>
                      <span
                        className="btn secondry d-block f14"
                        onClick={() => showDelivary()}
                        data-testid="select_credentials"
                      >
                        {address ? address.full_address : " Add my address"}
                        <i className="fa fa-angle-right right"></i>
                      </span>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiHomeLine />
                      Select outlet</label>
                    {method === 1 ? (
                      <span

                        style={address && props?.auth?.isAuthenticated
                          ? { opacity: 1.0, cursor: "pointer", pointerEvents: "auto" }
                          : { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }
                        }
                        className="btn secondry d-block f14"
                        onClick={() => {

                          showOutlet()

                        }}
                      >
                        {deliveryInformation.deliveryOutName ? deliveryInformation.deliveryOutName : "Select your outlet"}
                        <i className="fa fa-angle-right right"></i>
                      </span>) : (
                      <span
                        className="btn secondry d-block f14"
                        onClick={() => showPickFunction()}
                      >
                        {localStorage.out_name ? localStorage.out_name :
                          order.out_name ? order.out_name : "Select Outlet"}
                        <i className="fa fa-angle-right right"></i>
                      </span>)}
                  </div>

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiTimeLine />
                      {method === 1 ? "Delivery Time" : "Pickup Time"}</label>

                    <span
                      onClick={() => pickupDateFunction()}
                      className="btn secondry d-block f14 pickup-btn"
                    >
                      {order.date ? order.date : "Select date and"}&nbsp;
                      {order.time ? order.time : " Time"}
                    </span>
                  </div>
                  {/*<div className="form-group no">
                    <label className="control-label">Payment method</label>

                    <div className="row xsm">
                      <div className="col-12">
                        <span
                          onClick={() => { setShowPayment(true) }}
                          className="btn secondry d-block f14"
                        >
                          {paymentMethod ? paymentMethod[0].toUpperCase() + paymentMethod.substring(1, paymentMethod.length) : "Select payment"}
                        </span>
                      </div>
                    </div>
                  </div> */}
                  {/* NO PAYMENT FIELD HERE FOR DELIVERY OR PICKUP, THE GATEWAY IS PICKED AFTER THE BILLING SUMMARY */}

                </div>
              )}
              <div className="cart-gutter">
                {cartData && cartData.length > 0 && (
                  <div className="cart-head">
                    <span className="item">
                      {/* {props.cartData && props.cartData.count} Item(s)added */}
                      {cartData && cartData.length} Item(s)added
                    </span>
                    <button onClick={clearCart} className="btn primary action">
                      Clear Items
                    </button>

                  </div>
                )}
                <div className="cart-body">
                  {
                    cartData &&
                    cartData.length > 0 && (
                      <CartRender
                        updateCart={cartData}
                        cdata={cartData}
                        showChooseModal={openChooseModal}
                      />
                    )
                  }
                </div>
                <ChooseModal
                  show={showModal}
                  product={productDataModal}
                  replaceContext={replaceContext}
                  closeModal={() => {
                    setShowModal(false);
                    setReplaceContext(null);
                  }}
                  updateCart={(updatedOrder) => setCartData(updatedOrder)}
                />
              </div>
              {showBlockedPopup && (
                <div className="blocked-modal-overlay">
                  <div className="blocked-modal">
                    {!isApiErrorPopup && (
                      <>
                        <img src={exclamation} alt="Warning" className="warning-img" />
                        <h3 className="warning-title">Not For Selling</h3>
                      </>
                    )}

                    <div className="blocked-list">
                      {blockedList.map((item, i) => (
                        <div key={i} className="blocked-item">
                          <div style={{ fontSize: "12px", color: "#777", display: "inline" }}>
                            {getBlockedMessage(item)}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="popup-actions">
                      <button
                        className="btn secondary"
                        onClick={() => {
                          setShowBlockedPopup(false);
                          props.closeRightbar();
                        }}
                      >
                        Explore Menu
                      </button>

                      <button
                        className="btn primary"
                        onClick={() => setShowBlockedPopup(false)}
                      >
                        Review Cart
                      </button>
                    </div>

                  </div>
                </div>
              )}
              {(!cartData || cartData.count === 0) && (
                <div style={{ padding: "40% 0", display: "flex", justifyContent: "center" }}

                >
                  <div className="empty_cart">
                    <img
                      alt="cart"
                      className="align-self-center"
                      width="90px"
                      src={cartImg1}

                    />
                    <h5 style={{ paddingTop: '5%' }}>Your cart is empty</h5>
                    <p>Add something from the menu!</p>
                  </div>
                </div>
              )}
            </div>
            {
              method === 2 && estPrepTime !== undefined ?
                <div className={'cart-prep-time'}>
                  <div className={'cart-prep-text-container'}>
                    <div className={'cart-prep-text'}>
                      Estimated preparation time
                    </div>
                  </div>
                  <div className={'cart-prep-value-container'}>
                    <div className={'cart-prep-value'}>
                      {getEstimationRange(cartData)}
                    </div>
                  </div>
                </div> :
                null
            }
            <div className={`cart-foot ${showCartTotal ? "open" : ""}`}>
              <div className="cart-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Sub Total:</td>
                      <td data-testid="sub_total">
                        {cartData && cartData.sub && !isNaN(cartData.sub)
                          ? `$ ${parseFloat(cartData.sub).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>
                    {method === 1 ? (<tr>
                      <td>Delivery Charge:</td>
                      <td data-testid="final_delivery_charge">
                        {ownDelivery && cartData?.deliveryIsFree
                          ? "Free delivery"
                          : cartData && cartData.delivery_fee && !isNaN(cartData.delivery_fee)
                            ? `$ ${parseFloat(cartData.delivery_fee).toFixed(2)}`
                            : "$ 0"}
                      </td>
                    </tr>) : (<tr></tr>)}

                    {ownDeliveryHint && (<tr>
                      <td colSpan="2" style={{ color: ownDeliveryHint.tone === "warn" ? "#d9534f" : "#888", fontSize: "0.8em" }}>
                        {ownDeliveryHint.text}
                      </td>
                    </tr>)}

                    {cartData?.small_order_fee !== 0 ? (<tr>
                      <td>Small Order Charge</td>
                      <td data-testid="small_order_fee">
                        {cartData && cartData.small_order_fee && !isNaN(cartData.small_order_fee)
                          ? `$ ${parseFloat(cartData.small_order_fee).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>) : (<tr></tr>)}

                    <tr>
                      <td>
                        GST{" "}
                        <span style={{ color: "#888", fontSize: "0.9em" }}>
                          ({isInclusiveGST ? "Inclusive" : "Exclusive"})
                        </span>
                      </td>
                      <td data-testid="GST">
                        {cartData && cartData.gst && !isNaN(cartData.gst)
                          ? `$ ${parseFloat(cartData.gst).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div className="cart" style={{ display: "flex", alignItems: "center" }}>
                <button
                  disabled={
                    method === 2 ? (order?.date && order?.time ? false : true) : false
                  }
                  onClick={async () => {

                    if (!cartData || cartData.length === 0) {
                      ProcessCheckOut();
                      return;
                    }

                    const result = await checkAvailabilityBeforeCheckout();

                    if (result.error && cartData.length > 0) {
                      setBlockedList([
                        {
                          name: "Unable to verify items",
                          localProduct: {}
                        }
                      ]);
                      setShowBlockedPopup(true);
                      return;
                    }

                    if (result.blocked.length > 0) {
                      setBlockedList(result.blocked);
                      setShowBlockedPopup(true);
                      return;
                    }

                    ProcessCheckOut();
                  }}
                  className="btn primary"
                  style={{ flex: 1 }}
                >
                  {cartData && cartData.sum ? (
                    <>
                      {loading ? (
                        <>
                          <span className="loader"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <div style={{ textAlign: "center", width: "100%" }}>
                            <span>Next</span>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <span>Cart is Empty</span>
                      <span>|</span>
                      <span data-testid="final_total">$ 0</span>
                    </>
                  )}
                </button>

                {/* ✅ CART BUTTON WITH INLINE DESIGN */}
                {cartData && cartData.length > 0 ? (
                  <div
                    app-data="myCart"
                    onClick={props.closeRightbar}
                  >
                    <div ref={cartIconRef} className="cart-icon" style={{ marginLeft: "10px" }}>
                      <CartIcon count={cartData?.length || 0} size={45} />
                    </div>
                  </div>
                ) : (
                  <div
                    app-data="myCart"
                    onClick={props.closeRightbar}

                  >
                    <div ref={cartIconRef} className="cart-icon" style={{ marginLeft: "10px" }}>
                      <CartIcon count={cartData?.length || 0} size={45} />
                    </div>

                  </div>
                )}
              </div>
            </div>
          </div>
          :
          <div className={`modal_form mycart-dropdown billing-mode ${show ? "open" : ""}`} id="myCart">

            {/* ── Billing Header ── */}
            <div className="billing-header">
              <button className="billing-back-btn" onClick={handleBack} aria-label="Back">
                <IoIosArrowBack size={20} />
              </button>
              <div className="billing-header-center">
                <h2 className="billing-title">Billing Summary</h2>
                <p className="billing-subtitle">
                  {method === 1 ? "Delivery order" : "Pickup order"}
                </p>
              </div>
              <ModalCloseButton
                onClick={props.closeRightbar}
                style={{ position: "static", width: "32px", height: "32px" }}
              />
            </div>

            {/* ── Billing Body ── */}
            <div className="billing-scroll">

              {/* Order Items count chip */}
              {cartData?.length > 0 && (
                <div className="billing-items-chip">
                  🛒 &nbsp;{cartData.length} item{cartData.length !== 1 ? "s" : ""} in cart
                </div>
              )}

              {/* Breakdown card */}
              <div className="billing-card">

                <div className="billing-row">
                  <span className="billing-row-label">Sub Total</span>
                  <span className="billing-row-value">
                    {cartData?.sub && !isNaN(cartData.sub)
                      ? `$${parseFloat(cartData.sub).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

                {method === 1 && (
                  <div className="billing-row">
                    <span className="billing-row-label">Delivery Charge</span>
                    <span className="billing-row-value">
                      {ownDelivery && cartData?.deliveryIsFree
                        ? "Free delivery"
                        : cartData?.delivery_fee && !isNaN(cartData.delivery_fee)
                          ? `$${parseFloat(cartData.delivery_fee).toFixed(2)}`
                          : "$0.00"}
                    </span>
                  </div>
                )}

                {ownDeliveryHint && (
                  <div className="billing-row" style={{ paddingTop: 0 }}>
                    <span style={{ color: ownDeliveryHint.tone === "warn" ? "#d9534f" : "#888", fontSize: "0.8em" }}>
                      {ownDeliveryHint.text}
                    </span>
                  </div>
                )}

                {cartData?.small_order_fee !== 0 && (
                  <div className="billing-row">
                    <span className="billing-row-label">Small Order Fee</span>
                    <span className="billing-row-value">
                      {cartData?.small_order_fee && !isNaN(cartData.small_order_fee)
                        ? `$${parseFloat(cartData.small_order_fee).toFixed(2)}`
                        : "$0.00"}
                    </span>
                  </div>
                )}

                <div className="billing-row">
                  <span className="billing-row-label">
                    GST&nbsp;
                    <span className="billing-row-tag">
                      {isInclusiveGST ? "Incl." : "Excl."}
                    </span>
                  </span>
                  <span className="billing-row-value" data-testid="GST">
                    {cartData?.gst && !isNaN(cartData.gst)
                      ? `$${parseFloat(cartData.gst).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

                {roundVal > 0 && (
                  <div className="billing-row billing-row--saving">
                    <span className="billing-row-label">Rounding</span>
                    <span className="billing-row-value billing-row-value--red">
                      -${roundVal.toFixed(2)}
                    </span>
                  </div>
                )}

                <div className="billing-divider" />

                <div className="billing-row billing-row--total">
                  <span className="billing-total-label">Total</span>
                  <span className="billing-total-value" data-testid="final_total">
                    {cartData?.sum && !isNaN(cartData.sum)
                      ? `$${parseFloat(cartData.sum).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

              </div>

              {/* Payment method badge */}
              {paymentMethod && (
                <div className="billing-pay-badge">
                  <span className="billing-pay-label">Paying via</span>
                  <span className="billing-pay-value">
                    {paymentMethod === "Stripe" ? "💳 Credit / Debit Card" : paymentMethod}
                  </span>
                </div>
              )}

            </div>

            {/* ── Sticky Proceed Button ── */}
            <div className="billing-footer">
              <button
                className="billing-proceed-btn"
                onClick={handleProceed}
              >
                Confirm &amp; Proceed
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                  style={{ marginLeft: "8px" }}>
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </div>

          </div>
      }

      <div
        onClick={props.closeRightbar}
        className={`app-overlay ${show ? "open" : ""}`}
      ></div>
    </div>
  );
};

RightSidebar.propTypes = {
  closeRightbar: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  add_to_cart: state.products.add_to_cart,
  order: state.products.order,
  loading: state.products.loading,
  tax: state.products.tax,
  product: state.products.product,
  outlates: state.products.outlates,
  postal: state.postal,
  auth: state.auth,
  payment: state.products.payment,
  business_location: state.products.business_location,
  est_prep_time: state.products.est_prep_time,
  getCurrentOutlet: state.products.getCurrentOutlet,
  cartData: state.products.cartLocal,
  ownDeliveryQuote: state.products.own_delivery_quote
});
export default withTranslation()(
  connect(mapStateToProps, { clearCart, placeOrder, getTaxes, submitOrder, updateOrder, getOutletInformation, submitPayment, clearPayment, getPreparationTime, getProductsAvailability, getOwnDeliveryQuote })(
    RightSidebar
  )
);
